<template>
  <canvas ref="canvas" class="w-[1200px]" />
</template>

<script lang="ts" setup>
import { PositionCode } from '@rendora/common/entities/analysis_backend';
import { getDynamicQrcode } from '@rendora/common/features/contact/libs/useQrcode';
import { transformImage } from '~/utils';
import { getFeUrl } from '~/utils/url';

const baseUrl = transformImage(getFeUrl('/youyan-platform/qrcode/yycj-footer.png'));

const canvas = ref<HTMLCanvasElement>();

const getImage = async (url: string) => {
  return new Promise<HTMLImageElement>(resolve => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = url;
    img.onload = () => {
      resolve(img);
    };
  });
};

onMounted(async () => {
  try {
    const ctx = canvas.value?.getContext('2d');
    const qrcode = await getDynamicQrcode(
      PositionCode['魔珐有言-应用场景-底部'], // @xi18n-ignore
    );
    if (!qrcode) return;
    const [qrcodeImg, baseImg] = await Promise.all([getImage(qrcode), getImage(baseUrl)]);
    if (ctx) {
      canvas.value!.width = baseImg.width;
      canvas.value!.height = baseImg.height;
      ctx.drawImage(baseImg, 0, 0, baseImg.width, baseImg.height);
      ctx.drawImage(qrcodeImg, 1564, 134, 210, 210);
    }
  } catch (err) {
    console.error(err);
  }
});
</script>
